import { Card, CardContent, CardMedia, Typography } from "@mui/material"
import { Link } from "react-router-dom"

const SingleArticle = ({ post }) => {
  return (
    <Card
      sx={{ maxWidth: 345, textDecoration: "none" }}
      component={Link}
      to={`/posts/${post?._id}`}
    >
      <CardMedia
        sx={{ height: 140 }}
        image={`${process.env.REACT_APP_URL}${post?.selectedFile}`}
        alt={post?.title}
        title={post?.title}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {post?.title}
        </Typography>
      </CardContent>
    </Card>
  )
}
export default SingleArticle
